import Index from './Components/Index.vue';
import Page from './Components/Page.vue';
import NotFoundComponent from './Components/NotFoundComponent';

export const routes = [
    {
        path: '/',
        components: {
            default: Index
        }
    },
    {
        path: '/',
        name: 'index',
        components: {
            default: Index
        }
    },
    {
        path: '/page/:slug',
        name: 'page',
        components: {
            default: Page
        }
    },
    { path: '*', component: NotFoundComponent }
];
